import { render, staticRenderFns } from "./setting-kbank.vue?vue&type=template&id=6f2afc50"
import script from "./setting-kbank.vue?vue&type=script&lang=js"
export * from "./setting-kbank.vue?vue&type=script&lang=js"
import style0 from "./setting-kbank.vue?vue&type=style&index=0&id=6f2afc50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports